const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

export const getHeadingDesc = (content, fullDescription = false) => {
  const result = {
    heading: '',
    description: '',
  }
  if (!cheerio || typeof content !== 'string') return result

  const $ = cheerio.load(content, null, false)

  // Iterate through all heading tags (h1–h6)
  const headingHtml = $('h1, h2, h3, h4, h5, h6').first()

  if (headingHtml.length) {
    // If a heading exists, extract its text
    result.heading = $(headingHtml).text().trim()

    if (fullDescription) {
      // Get everything after the heading
      const descriptionParts: string[] = []
      $(headingHtml)
        .nextAll()
        .each((_, el) => {
          descriptionParts.push($(el).text())
        })
      result.description = descriptionParts.join(' ').trim()
    } else {
      // Only get the next paragraph
      const nextP = $(headingHtml).nextAll('p').first()
      if (nextP.length) {
        result.description = nextP.text().trim()
      }
    }
  } else {
    const descriptionParts: string[] = []
    // No heading found — use the whole content as description
    $('p').each((_, el) => {
      descriptionParts.push($(el).text())
    })
    result.description = descriptionParts.join(' ').trim()
  }

  return result
}
